<div class="card">
  <app-header
    titulo="Painel de Contratos"
    descricao="Painel de integração dos contratos"
  ></app-header>

  <p-tabView>
    <p-tabPanel header="Contratos">
        <app-contratos></app-contratos>
    </p-tabPanel>
    <p-tabPanel header="Processamento"> 
      <app-processamentocontrato></app-processamentocontrato>
    </p-tabPanel>
    <p-tabPanel header="Parâmetros">
      <app-tmalist></app-tmalist>
    </p-tabPanel>
    <p-tabPanel header="Processos"> 
      <app-listarprocessos processos="CONTRATOS"></app-listarprocessos>
    </p-tabPanel>
  </p-tabView>
</div>
